import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import withRouter from 'src/routes/withRouter';
import { Button, Checkbox, Menu, Modal } from 'antd';
import { appInfo as appInfoApi } from 'src/api';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        const appCheckedList = ModulesAction.getCheckedAppInfo();
        this.setInfoTips(appCheckedList[0]);
    }
    private setInfoTips = async (value) => {
        const param = {
            appId: value.appId
        };
        const data = await appInfoApi.getPermissions(this, param);
        if (data.er) {
            return;
        }
        const appAGreementInfo = data.res;
        const appAgreementContent = appAGreementInfo.appAgreementContent ? appAGreementInfo.appAgreementContent : '暂无协议';
        const appAgreementContentDom = (
            <div className={css.infoTipsContent}>
                <div className={css.infoTipsMTitle}>激活提示</div>
                <div className={css.infoTipsMContent}>
                    接受许可协议以激活。
                    {
                        appAGreementInfo.appCategories.map(item => {
                            return (<span key={item.apiCategoryId}>&nbsp;/&nbsp;该应用会访问{item.apiCategoryName}</span>);
                        })
                    }
                </div>
                <div className={css.infoTipsMTitle}>用户协议</div>
                <div className={css.infoTipsMContent}>
                    <div dangerouslySetInnerHTML={{ __html: appAgreementContent }} />
                </div>
            </div>
        );
        this.modulesState.appAgreementContentDom = appAgreementContentDom;
        this.setModulesState();
    }
    private getMenuList = (appCheckedList: Array<any>) => {
        return appCheckedList.length > 0 && appCheckedList.map((appInfo, index) => {
            return (
                <Menu.Item key={appInfo.appId + ''} onClick={(e) => { this.setInfoTips(appInfo); }}>
                    <div className={css.menuItem}>
                        <Checkbox
                            key={appInfo.appId + ''}
                            onChange={(e) => { ModulesAction.checkcedAgreeListHandle(e, appInfo); }}
                            checked={this.modulesState.checkcedAgreeList.has(appInfo.appId)}
                        >
                        </Checkbox>
                        <p>{appInfo.appName}</p>
                    </div>
                </Menu.Item>
            );
        });
    }
    private getModalContent = (key: any) => {
        const appCheckedList = ModulesAction.getCheckedAppInfo();
        const defaultKey = key ? key : appCheckedList.length > 0 ? appCheckedList[0].appId + '' : '';
        return (
            <div className={css.ModalWrapper}>
                <div>
                    <Menu
                        onClick={(e) => { this.getModalContent(e.key); }}
                        style={{ width: 200 }}
                        defaultSelectedKeys={[defaultKey]}
                        mode="inline"
                        inlineIndent={8}
                    >
                        <Menu.Item key="" disabled={true}>
                            <div className={css.menuItem}>
                                <Checkbox
                                    onChange={() => { ModulesAction.checkcedAgreeAll(); }}
                                    checked={this.modulesState.isCheckcedAgreeAll}
                                >
                                </Checkbox>
                                <p>全选</p>
                            </div>
                        </Menu.Item>
                        {this.getMenuList(appCheckedList)}
                    </Menu>
                </div>
                <div>
                    {this.modulesState.appAgreementContentDom }
                </div>
            </div>
        );
    }
    render() {
        const isReadCheckd = this.modulesState.isReadCheckd;
        return (
            <div className={css.carouselbox} >
                <Modal
                    title={null}
                    visible={this.modulesState.activTipsM}
                    width={'700px'}
                    footer={null}
                    className={css.infoTipsM}
                    bodyStyle={{ height: '550px' }}
                    onCancel={() => {
                        ModulesAction.activeTipsM(false);
                    }}
                >
                    {this.getModalContent(null)}
                    <div className={css.infoTipsFooter}>
                        <div className={css.infoTipsFooterCheck}>
                            <Checkbox value={isReadCheckd} onChange={ModulesAction.onChangeCheck}>
                                <span className={css.readAgree}>我已阅读并同意</span>
                            </Checkbox>
                        </div>
                        <div className={css.infoTipsFooterSubmit}>
                            <Button type="link" disabled={!isReadCheckd || !this.modulesState.isCheckcedAgreeAll} onClick={() => ModulesAction.appInstanceActivate()} className={css.footerBts}>
                                确定
                            </Button>
                            <Button type="link" className={css.footerBts} onClick={() => ModulesAction.activeTipsM(false)}>
                                取消
                            </Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/AppBatchActivated/UI.Components/AgreementTips.tsx